import React from 'react';
import PropTypes from 'prop-types';
import { SegmentedControl } from './ui';

const DISPLAY_MODE_ITEMS = [
  { value: 'git_effort', label: 'R.E.V' },
  { value: 'investment', label: 'Value ($)' }
];

const DisplayModeToggle = ({ value, onChange }) => (
  <SegmentedControl
    items={DISPLAY_MODE_ITEMS}
    value={value}
    onChange={onChange}
  />
);

DisplayModeToggle.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};

export default DisplayModeToggle;
